import request from '@/utils/request'

// Note: Customer creation is not exposed in the API
// Customers are created through other means (e.g., registration)

export function getCustomerList(params) {
  return request({
    url: '/api/admin/Customer',
    method: 'get',
    params
  })
}

export function getCustomerDetail(id) {
  return request({
    url: `/api/admin/Customer/${id}`,
    method: 'get'
  })
}

// POST /api/admin/Customer - Create new customer
export function createCustomer(data) {
  return request({
    url: '/api/admin/Customer',
    method: 'post',
    data
  })
}

// PUT /api/admin/Customer - Create or update customer (uses UpdateCustomerCommand)
export function upsertCustomer(data) {
  return request({
    url: '/api/admin/Customer',
    method: 'put',
    data
  })
}

// PUT /api/admin/Customer/{id} - Update specific customer
export function updateCustomer(id, data) {
  return request({
    url: `/api/admin/Customer/${id}`,
    method: 'put',
    data
  })
}

export function getCustomerBookings(id, params) {
  return request({
    url: `/api/admin/Customer/${id}/bookings`,
    method: 'get',
    params
  })
}

export function getCustomerCharges(id, params) {
  return request({
    url: `/api/admin/Customer/${id}/charges`,
    method: 'get',
    params
  })
}

export function deleteCustomer(id) {
  return request({
    url: `/api/admin/Customer/${id}`,
    method: 'delete'
  })
}

// Get current customer info (me)
export function getCustomerMe() {
  return request({
    url: '/api/Customers/me',
    method: 'get'
  })
}
